import { render } from "./PrimaryButton.vue?vue&type=template&id=1f4339d0&scoped=true&ts=true&lang=pug"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts"

import "./PrimaryButton.vue?vue&type=style&index=0&id=1f4339d0&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4339d0"]])

export default __exports__